import moment from 'moment';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {reportClearData, reportLoadData} from '../redux/actions/ReportsActions';
import ReportDefinitions from '../../../common/config/ReportDefinitions';
import {wizardRoutes} from '../../../wizard/common/Routes/WizardRoutes';
import {pushHistory} from '../../../../core/modules/common/tools/HistoryTools';
import {getSelectionCriteria} from '../../../wizard/common/redux/selectors/SelectionCriteriaWizardSelectors';
import SelectionCriteriaDto from '../models/SelectionCriteriaDto';
import {dayPeriodSelected} from '../../../wizard/period-selector/redux/actions/PeriodSelectionActions';
import {createReqParams} from '../../../user/redux/actions/UserActions';

export class ReportNavigationButton extends Component {
  navigate = () => {
    const {
      reportId,
      mainReportId,
      requestParams,
      reportsToBeCleared,
      selectionCriteriaOptions,
      header,
    } = this.props;
    if (header === 'PREDES') {
      requestParams.drilldownColumn = 'N';
    } else if (header === 'CARDIT') {
      requestParams.drilldownColumn = 'Y';
    } else if (header === 'PREDES - CARDIT') {
      requestParams.drilldownColumn = 'D';
    } else if (header === 'Inbound Operator score') {
      requestParams.direction = 'O';
    } else if (header === 'Global score') {
      requestParams.direction = 'I';
    } else if (header === 'Operator inbound') {
      requestParams.direction = 'I';
    } else if (header === 'Operator outbound') {
      requestParams.direction = 'O';
    }
    const report = ReportDefinitions[reportId];
    // Add selectionCriteria to request params if includeSelectionCriteria is true
    if (selectionCriteriaOptions.includeSelectionCriteria) {
      const selectionCriteria =
        new SelectionCriteriaDto(this.props.selectionCriteria, report.selectionCriteria.items);
      Object.keys(selectionCriteria).forEach((key) => {
        if (key in requestParams === false) {
          requestParams[key] = selectionCriteria[key];
        }
      });
    }
    if (requestParams.date) {
      const abc = this.props.requestParams.period.from;
      const period = {
        ...this.props.selectionCriteria.period,
        startDate: moment(abc).toDate(),
        endDate: moment(abc).toDate(),
        dayPicker: {
          startDate: new Date(abc),
          endDate: new Date(abc),
        },
      };
      this.props.dayPeriodSelected(period);
    }
    this.props.createReqParams(requestParams);
    if (reportsToBeCleared && reportsToBeCleared.length) {
      reportsToBeCleared.forEach((id) => {
        this.props.reportClearData(ReportDefinitions[id]);
      });
    }
    this.props.reportLoadData(report, mainReportId, requestParams);
    const routes = wizardRoutes(reportId);
    pushHistory(routes.generateReport);
    return false;
  };

  renderNoData() {
    return (
      <div>
        {this.props.children}
      </div>
    );
  }

  render() {
    if (this.props.children === '-' && this.props.mainReportId !== 'PAPER_FREE_MONITORING_POST_900_SUMMARY' && this.props.mainReportId !== 'PAPER_FREE_MONITORING_POST_902_SUMMARY') {
      return this.renderNoData();
    }
    return (
      <button type="button" className="btn-link" onClick={this.navigate}>
        {this.props.children}
      </button>
    );
  }
}

const mapStateToProps = state => ({ selectionCriteria: getSelectionCriteria(state) });

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    reportClearData,
    reportLoadData,
    dayPeriodSelected,
    createReqParams,
  }, dispatch);

ReportNavigationButton.defaultProps = {
  requestParams: {},
  selectionCriteriaOptions: {
    includeSelectionCriteria: false,
  },
};

ReportNavigationButton.propTypes = {
  reportId: PropTypes.string,
  mainReportId: PropTypes.string,
  requestParams: PropTypes.objectOf(PropTypes.shape),
  selectionCriteriaOptions: PropTypes.objectOf(PropTypes.shape),
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.element,
  ]),
  selectionCriteria: PropTypes.objectOf(PropTypes.shape),
  reportLoadData: PropTypes.func,
  reportClearData: PropTypes.func,
  reportsToBeCleared: PropTypes.arrayOf(PropTypes.string),
  dayPeriodSelected: PropTypes.func,
  createReqParams: PropTypes.func,
  header: PropTypes.string,
};

export default connect(mapStateToProps, mapDispatchToProps)(ReportNavigationButton);
